import Vue from 'vue'
import App from './App.vue'
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import http from '@/api/config';
import move from './tools/move';
import {Base64} from 'js-base64';
import Meta from 'vue-meta';
import Video from 'video.js'
import 'video.js/dist/video-js.css';
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import VueCoreVideoPlayer from 'vue-core-video-player'

Vue.use(VueCoreVideoPlayer,{
  lang: 'zh-CN'
})
Vue.use(VueVideoPlayer)
// import 'videojs-flash'
const hls =require("videojs-contrib-hls")
// import vConsole from '@/tools/vconsole'

// Vue.prototype.vConsole = vConsole;
// Vue.use(hls)
Vue.prototype.$video = Video

// 使用vue-meta
Vue.use(Meta);
Vue.use(Base64);
Vue.use(ElementUI);
Vue.config.errorHandler = (err, vm, info) => {
  console.log(err);
}
Vue.prototype.$http = http;
Vue.prototype.$move = move;
Vue.config.productionTip = false;
new Vue({
    router,
    render: h => h(App),
    mounted () {

      document.dispatchEvent(new Event('render-event'))
     
      }
}).$mount('#app')